import axios from "axios";
import { uiRequestInterceptor } from "@/interceptors/ui-request.interceptor";
import { uiResponseInterceptor } from "@/interceptors/ui-response.interceptor";
import { errorResponseToastInterceptor } from "@/interceptors/error-response-toast.interceptor";
import { i18nInterceptor } from "@/interceptors/i18n.interceptor";

const axiosHttpClient = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL
});

// Register global request interceptors
axiosHttpClient.interceptors.request.use(uiRequestInterceptor.onFulfilled);
axiosHttpClient.interceptors.request.use(i18nInterceptor.onFulfilled);

// Register global response interceptors
axiosHttpClient.interceptors.response.use(
  uiResponseInterceptor.onFulfilled,
  uiResponseInterceptor.onRejected
);

axiosHttpClient.interceptors.response.use(
  undefined,
  errorResponseToastInterceptor.onRejected
);

export default axiosHttpClient;
